export const GATEPASS_STATUS = {
  CREATED: 'created',
  SUBMITTED: 'submitted',
  IN_TRANSIT: 'in transit',
  DONE: 'done',
  DISCARDED: 'discarded',
};

export const getGatePassBadgeColor = status => {
  switch (status) {
    case GATEPASS_STATUS.CREATED:
      return 'secondary';
    case GATEPASS_STATUS.SUBMITTED:
      return 'primary';
    case GATEPASS_STATUS.IN_TRANSIT:
      return 'warning';
    case GATEPASS_STATUS.DONE:
      return 'success';
    case GATEPASS_STATUS.DISCARDED:
      return 'danger';
    default:
      return 'light';
  }
};
